var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticStyle: { height: "450px" } },
        [
          _c("TaskSkillMap", {
            ref: "skillMap",
            attrs: { mapId: _vm.mapId, taskId: _vm.taskId },
            on: { handleGetPointList: _vm.handleGetPointList }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "cell-style": _vm.isCenter,
            "header-cell-style": _vm.isCenter,
            "highlight-current-row": true
          },
          on: { "row-click": _vm.handleRowClick }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "50" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumns, function(column, index) {
            return [
              column.isShow
                ? _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      formatter: column.formatter,
                      width: column.width,
                      sortable: column.sortable
                    }
                  })
                : _vm._e()
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "280", prop: "" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          title: "配置技能",
                          size: "mini"
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleSetSkillParam(scope.row.id)
                          }
                        }
                      },
                      [_vm._v("配置技能")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", title: "删除", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.delMenu(scope.row.id)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            modal: false,
            title: _vm.title,
            width: "600px",
            visible: _vm.addPos,
            "before-close": _vm.closeDiglog,
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.addPos = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "addPos",
              attrs: {
                model: _vm.addData,
                rules: _vm.rules,
                "label-width": "160px",
                size: "small"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "380px" },
                  attrs: { label: "停留时间：", prop: "stayTime" }
                },
                [
                  _c("el-time-picker", {
                    attrs: {
                      "value-format": "HH:mm:ss",
                      placeholder: "任意时间点"
                    },
                    model: {
                      value: _vm.addData.stayTime,
                      callback: function($$v) {
                        _vm.$set(_vm.addData, "stayTime", $$v)
                      },
                      expression: "addData.stayTime"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: " " } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSetStayTime }
                    },
                    [_vm._v("提交")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.onCencal } }, [
                    _vm._v("取消")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }